var styles = {"action":"AlertActionButton-module_action__xBOZi"};

export { styles as default };
